module.exports = __webpack_public_path__ + "img/hero1.75d15d60.webp";